import axios from "axios";
import { validateUserType } from "../ValidateUserType";

const API = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

API.interceptors.request.use((req) => {
  try {
    if (JSON.parse(localStorage.getItem("profile")).token) {
        req.headers.Authorization = `Bearer ${ 
        JSON.parse(localStorage.getItem("profile")).token
      }`;
    }
    return req;
  } catch (error) {
    console.error("error",error);
  }
});


API.interceptors.response.use(function (response) {

  return response;
}, function (error) {
  if(error?.response?.data?.statusCode === 401 || error?.response?.data?.statusCode === 403 ){
    localStorage.clear()
    localStorage.removeItem('persist:root');
    window.location = `${window.location.protocol}//${window.location.host}/login`
  }

  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error);
});

//------------------------------------------------------------------------------------------------Arborist Auth
export const arboristsLogin = (data)=>axios.post(`${process.env.REACT_APP_API_BASE_URL}${validateUserType()?"/company/login":"/arborist/login"}`, data);
export const generatePassCode =(data)=>axios.post(`${process.env.REACT_APP_API_BASE_URL}${validateUserType()?"/company/forgotpasswordgeneratecode":"/arborist/forgotpasswordgeneratecode"}`, data)
export const forgotPassword =(data)=>axios.post(`${process.env.REACT_APP_API_BASE_URL}${validateUserType()?"/company/forgotpassword":"/arborist/forgotpassword"}`, data)
export const fetchArboristProfile =()=>API.get("arborist/profile")
export const editArboristProfile =(data)=>API.put("arborist/profile", data)
export const arboristResetPassword =(data)=>API.post("arborist/resetpassword", data)
export const fetchAllArbors =()=>API.get("company/arborists")
export const addCompanyArborist =(data)=>API.post("company/arborist", data)
export const editCompanyArbor =(arboristId, data)=>API.put(`company/arborist/${arboristId}`, data)
export const deleteCompanyArbor =(arboristId)=>API.delete(`company/arborist/${arboristId}`)

//------------------------------------------------------------------------------------------------------Client
export const addArboristClient =(data)=>API.post("arborist/client", data)
export const fetchAllClients =()=>API.get("arborist/clients")
export const deleteClient =(clientId)=>API.delete(`arborist/client/${clientId}`)
export const editClient =(clientId, data)=>API.put(`arborist/client/${clientId}`, data)
export const fetchClientTypes =()=>API.get("arborist/clienttypes")

export const fetchAllArborClients =(arboristId)=>API.get(`company/clients/${arboristId}`)//for comapny 
export const fetchCompanyClientTypes =()=>API.get("company/clienttypes")//for company
export const addCompanyClient =(data)=>API.post("company/client", data)//for company
export const editCompanyClient =(clientId, data)=>API.put(`company/client/${clientId}`, data)//for company
export const deleteCompanyClient =(arboristId,clientId)=>API.delete(`company/client/${arboristId}/${clientId}`)//for company

//------------------------------------------------------------------------------------------------------Properties
export const addProperty =(data)=>API.post("arborist/property", data)
export const fetchProperties =()=>API.get("arborist/properties")
export const fetchClientProperty=(clientId)=>API.get(`/arborist/client/${clientId}/properties`)
export const editProperties =(propertyId, data)=>API.put(`arborist/property/${propertyId}`, data)
export const deleteProperty =(propertyId)=>API.delete(`arborist/property/${propertyId}`)

export const fetchAllArborProperties =(arboristId,clientId)=>API.get(`company/properties/${arboristId}/${clientId}`)//for comapny
export const addCompanyProperty =(data)=>API.post("company/property", data)
export const editCompanyProperties =(propertyId, data)=>API.put(`company/property/${propertyId}`, data)
export const deleteCompanyProperty =(arboristId,clientId)=>API.delete(`company/property/${arboristId}/${clientId}`)

//---------------------------------------------------------------------------------------------------------Tree
export const fetchTreeSpecies =()=>API.get("arborist/species")
export const fetchRecomendations =()=>API.get("arborist/recommendations")
export const fetchHealthRates =()=>API.get("arborist/healthrates")
export const fetchJurisdiction =()=> API.get("arborist/jurisdictions")

export const fetchTrees = (reportId)=>API.get(`arborist/report/${reportId}/trees`)
export const saveTree = (reportId, data)=> API.post(`arborist/report/${reportId}/tree`, data)
export const updateTree = (reportId, treeId, data)=>API.put(`arborist/report/${reportId}/tree/${treeId}`, data)
export const deleteTree = (reportId, treeId)=> API.delete(`arborist/report/${reportId}/tree/${treeId}`)


//---------------------------------------------------------------------------------------------------------Reports
export const fetchReports =()=>API.get("arborist/reports")
export const saveReport =(data)=>API.post("arborist/report", data)
export const editReport =(reportId, data)=>API.put(`arborist/report/${reportId}`, data)
export const deleteReport =(reportId)=>API.delete(`/arborist/report/${reportId}`)



